import {Spin} from "antd";
import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import {useAuth} from "../../context/authContext";
import ContactsList from "./components/contacts-list/ContactsList";
import useContactsController from "../../controllers/contacts-controller";
import FeedbackForm from "./components/feedback-form/FeedbackForm";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import ContactModal from "../../components/modals/contact-modal/ContactModal";
import "./style.less"
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import React from "react";
import {CustomerServiceOutlined} from "@ant-design/icons";

const ContactsPage = () => {
  const {canManageContent} = useAuth()
  const contactsController = useContactsController()
  const {isLoading, toggleModal, isModalOpen} = contactsController


  return <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Контактна інформація</div>
          </div>
        }
        extra={canManageContent ? <AddActionButton size={"small"} onClick={toggleModal}/> : undefined}
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content contacts-page">
      <Spin spinning={isLoading}>
        <section className="contacts-section">
          <div className="contacts-intro">
            <div className="contacts-intro__icon"><CustomerServiceOutlined/></div>
            <div>
              <div className="contacts-intro__eyebrow">Ми на зв’язку</div>
              <h1 className="contacts-intro__title">Контактна інформація</h1>
              <p className="contacts-intro__description">
                Зателефонуйте, напишіть нам або скористайтеся формою зворотного зв’язку — ми допоможемо знайти потрібну інформацію.
              </p>
            </div>
          </div>
          <div className="contacts-layout">
            <ContactsList contactsController={contactsController}/>
            <FeedbackForm/>
          </div>
        </section>
      </Spin>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
    {isModalOpen && <ContactModal contactController={contactsController}/>}
  </>
}

export default ContactsPage
